import { APOLLO_CLIENTS } from 'common/dictionary.js'

const GO_QUERIES = new Set([
  'sortedGames',
  'gameGroup',
  'gameGroups',
  'manufacturer',
  'manufacturerList',
  'gameGroupList',
  'documentTypes',
  'imageContentList',
  'bigWin',
  'userLatestGames',
  'userLatestGamesList',
  'propsContent',
  'propsContentList',
  'imageContentList',
  'jackpots',
  'jackpotWins',
  'randomGame',
  'loyaltyProducts',
  'currentUser',
  'siteInfo',
  'sumRegionRules',
  'lpLevels',
  'lpCategories',
  'lpAchievements',
  'lpNextSeason',
  'lpLeaderboard',
  'loyaltyProductsOlpExchange',
  'lpSeasonCityLevel',
  'loyaltyProducts',
  'loyaltyProductCategories',
  'loyaltyProductManufacturers',
  'getImageContentList',
  'lpTempTasksLevel',
  'documentMasks',
  'lpSeasonLeaderboard',
  'userTracking',
  'fastCashbackGames',
  'fastCashbackGamesIds',
  'newCompetition',
  'newCompetitions',
  'competitionGameIds',
  'competitionsGames',
  'recomendedGames',
  'lpDailyRewardSequence',
  'lpDailyRewards',
  'userLootboxes',
])

const GO_MUTATIONS = new Set([
  'requestReward',
  'userTracking',
  'requestDailyReward',
  'userLootboxOpen',
  'userLootboxCraftBatch',
])

export function getApolloClientID(document) {
  if (!document || !Array.isArray(document.definitions)) {
    return APOLLO_CLIENTS.default
  }

  const operationDefinition = document.definitions.find((def) => def.kind === 'OperationDefinition')

  const firstFieldName = operationDefinition?.selectionSet?.selections?.[0]?.name?.value
  const goOperationsByType = {
    query: GO_QUERIES,
    mutation: GO_MUTATIONS,
  }
  const goOperations = goOperationsByType[operationDefinition?.operation]
  return goOperations?.has(firstFieldName) ? APOLLO_CLIENTS.clientGo : APOLLO_CLIENTS.default
}
